import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/uiDir/button";
import { ActivityFeed } from "@/components/dashboard/ActivityFeed";

const Activities = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-10 max-w-4xl">
        <Link to="/dashboard">
          <Button variant="ghost" className="mb-4">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </Link>
        <h1 className="text-4xl font-heading font-bold mb-2">Activity</h1>
        <p className="text-muted-foreground mb-6">All recent updates in one place</p>

        <ActivityFeed />
      </div>
    </div>
  );
};

export default Activities;
